import { ServerCheckoutResultType } from '../analytics/posDashboard.types';
import { BreakInfoStatusEnum, EmployeeBreakType } from '../break/break.types';
import { BaseResponseType } from '../cognito/authResponse.types';

export const timeZoneName = 'America/Los_Angeles';
export interface breakType {
  duration?: number;
  id?: number;
  payable?: boolean;
  type?: EmployeeBreakType;
}

export interface BreakInfoType {
  id: number;
  isPaid?: boolean;
  startTime?: Date;
  endTime?: Date;
  totalHours?: number;
  createdAt: Date;
  updatedAt: Date;
  break?: breakType;
  restaurantBreakLaw?: RestaurantBreakLaw;
  status?: BreakInfoStatusEnum;
  breakType?: EmployeeBreakType;
}
export interface RestaurantBreakLaw {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  breakLaw: BreakLaw;
}

export interface BreakLaw {
  id: number;
  state: string;
  duration: number;
  quantity: number;
  breakType: EmployeeBreakType;
  shiftHourRangeStart: number;
  shiftHourRangeEnd: number;
  createdAt: Date;
  updatedAt: Date;
  isWaivable: boolean;
  isPaid: boolean;
}

export interface TimeLogemployeeRolesType {
  salary?: number;
  payType: string;
  fixedPeriod?: string;
}
export interface TimeLogRoleType {
  roleName: string;
  userRoles: TimeLogemployeeRolesType[];
}

export enum MealPenalty {
  None = '0',
  One = '1',
  TWO = '2',
}

export interface TimeLogType {
  id: number;
  timeIn?: Date;
  timeOut?: Date;
  totalHours?: number;
  createdAt?: Date;
  role?: TimeLogRoleType;
  breakInfos?: BreakInfoType[];
  status?: TimeLogStatus;
  mealPenalty?: MealPenalty;
}

export interface ClockInType {
  roleId: number;
}

export interface BreakInType {
  breakLawId: number;
  status: BreakInfoStatusEnum;
  reason?: string;
  breakStartTime?: Date;
}

export interface TimeLogResponseType extends BaseResponseType {
  data: ServerCheckoutResultType | null;
}

export interface TimeLogBreakoutResponseType extends BaseResponseType {
  data: BreakPendingType;
}

export interface BreakPendingType {
  breakPending: boolean;
}

export interface TimeCardsByDateType {
  date: Date;
  data: TimeLogType[];
  to?: Date;
}

export interface AggregatedBreakInfoType {
  paid: boolean;
  type: EmployeeBreakType;
  duration: number;
  totalHours: number;
}

export interface PayPeriodType {
  startDate: Date;
  endDate: Date;
}

export interface BreakTakenInfoType {
  breaksList?: AggregatedBreakInfoType[];
}

export interface EmployeeTimeCardType {
  currentPayPeriod: PayPeriodType;
  previousPayPeriod: PayPeriodType;
  hasMultipleRoles: boolean;
  currentBreakInfos: (BreakTakenInfoType | null)[];
  previousBreakInfos: (BreakTakenInfoType | null)[];
  currentTimeCardsByDate: TimeCardsByDateType[];
  previousTimeCardsByDate: TimeCardsByDateType[];
  column?: string[];
  isPayrollSchedule?: boolean;
}

export interface employeeMetaType {
  employeeId: number;
  role: string;
  salary: number;
}

export interface EmployeeTimeCardsSummaryType {
  subTotal?: number;
  tips?: {
    tipsBeforePooling: number;
    tipsAfterPooling: number;
  };
  grossPay?: number;
  paidBreaks?: number;
  unpaidBreaks?: number;
  totalBreaks?: number;
  totalWorkingTime?: number;
  overtimeHours?: number;
  regularHours?: number;
  doubletimeHours?: number;
  employeeMeta?: any;
  weeklyOvertimeHours?: number;
}
export interface EmployeeTimeCardsSummaryResponseType extends BaseResponseType {
  data: EmployeeTimeCardsSummaryType;
}

export interface EmployeeTimeCardResponseType extends BaseResponseType {
  data: EmployeeTimeCardType;
}
export interface PreviousLog {
  id: number;
  timeIn: Date;
  timeOut: Date;
  updatedByFN: string;
  updatedById: string;
  updatedByLN: string;
}
export interface CurrentLog {
  id: number;
  time_in: Date;
  time_out: Date;
  total_hours: number;
  created_at: Date;
  updated_at: Date;
  roleId: number;
  employeeUserRestaurantId: number;
  oldRecord: PreviousLog[];
}
export interface TimeLogHistory {
  currentTimeCardsLogs: CurrentLog[];
  previousTimeCardsLogs: CurrentLog[];
}

export interface EmployeeTimeLogHistoryResponseType extends BaseResponseType {
  data: TimeLogHistory;
}

export enum TimeLogStatus {
  SELF = 'SELF',
  AUTO = 'AUTO',
}

interface ClockingInfo {
  id: number;
  timeIn: string;
  timeOut: string;
  totalHours: number;
  createdAt: string;
  updatedAt: string;
  status: string;
  role: {
    id: number;
    name: string;
    key: string;
    tag: string[];
    createdAt: string;
    updatedAt: string;
    createdBy: string | null;
    updatedBy: string | null;
    status: boolean;
  };
}

interface BreaksList {
  end_time: string | null;
  breakId: number;
  start_time: string;
  totalHours: number;
  employeeId: string;
}

interface TimeData {
  clockingInfo: ClockingInfo[];
  breaksList: BreaksList[];
  totalWorkingTime: number;
}

export interface EmployeeData {
  employeeId: string;
  employeeName: string;
  roleId: number;
  roleName: string;
  timeData: TimeData;
  hasClockedOut: boolean;
}

export interface DayWiseBreaks {
  id: number;
  is_paid: boolean;
  start_time: string;
  end_time: string;
  total_hours: number;
  payable: boolean;
  type: string;
  duration: number;
}
export interface DayWiseEntriesTimeCard {
  id: number;
  time_in: string;
  time_out: string;
  total_hours: number;
  status: TimeLogStatus;
  salary: number;
  roleId: number;
  totalUnpaidBreaksHours: number;
  totalPaidBreaksHours: number;
  breaks: DayWiseBreaks[];
}
export interface DayWiseEntitiesTimeCard {
  entry_date: string;
  sum_total_hours: number;
  overtimes: boolean;
  doubleovertime: boolean;
  multipleRoles: boolean;
  entry_times: DayWiseEntriesTimeCard[];
}

export enum PayRateConfiguration {
  STANDARD = 'STANDARD',
  HIGHEST_SALARY = 'HIGHEST_SALARY',
  AVERAGE_SALARY = 'AVERAGE_SALARY',
}

export interface RestaurantConfig {
  // Daily Overtime pay rates: if dailyOverTimeThresholdHours have some value and overTimesPayRate is undefind then we take default value of 1.5 and 2.0
  overTimesPayRate?: number;
  doubleOverTimesPayRate?: number;

  // Daily Overtime Rules
  dailyOverTimeThresholdHours?: number; // Hours after which overtime applies (e.g., 8 for CA)
  dailyDoubleOverTimeThresholdHours?: number; // Hours after which double overtime applies (e.g., 12 for CA)

  // 7th Consecutive Workday Rules
  isSeventhConsecutiveDay?: boolean;

  payRateConfig?: PayRateConfiguration;

  // If defined, this value indicates that once an employee has completed 40 working hours
  // in a week, the regular pay rate calculation is skipped, and the pay  is multiplied by the specified value = pay rate * working hours
  weeklyPayRate?: number;

  weeklyOverTimeOptional?: boolean; // If true, weekly overtime is optional and can be waived by the employer. If false or undefined, weekly overtime is mandatory.
}

export interface BreakInfoRedisData {
  isUserOnBreak: boolean;
  activeBreak: breakType | null;
  breakInfos: BreakInfoType[];
}

export interface BreakInfoOnLoginType {
  breakTaken: boolean;
  isActive: boolean;
  paid: boolean;
  type: EmployeeBreakType;
  duration: number;
  totalHours: number | null;
}

export enum PayPeriod {
  CURRENT = 'Current',
  PREVIOUS = 'Previous',
  CUSTOM = 'Custom',
}

export interface EmployeeSummary {
  tips: number;
  grossPay: number;
  totalWorkingTime: number;
  overtimeHours: number;
  doubletimeHours: number;
  regularHours: number;
  weeklyOvertimeHours: number;
  paidBreaks: number;
  unpaidBreaks: number;
  totalBreaks: number;
  subTotal: number;
  entries: TimeCardEntry[];
  employeeMeta: EmployeeMeta;
  employeeRoles: EmployeeRole[];
}
interface TimeCardEntry {
  id: number;
  time_in: string; // ISO string
  time_out: string; // ISO string
  total_hours: number;
  status: string;
  salary: number;
  roleId: number;
  totalUnpaidBreaksHours: number;
  totalPaidBreaksHours: number;
  roleName: string;
  fullName: string;
  sale: SaleInfo | null;
  breaks: any[]; // Empty array always
  overTimesHours: number;
  doubleOverTimeOver: number;
}
interface SaleInfo {
  gratuity: number | null;
  netSales: number | null;
  tips: number | null;
}
interface EmployeeMeta {
  roleId: number;
  role: string;
  salary: number;
  employeeId: number;
  payType: string;
}
interface EmployeeRole {
  roleId: number;
  role: string;
  salary: number;
  employeeId: number;
  payType: string;
  regularHours: number;
  overtimeHours: number;
  doubleOvertimeHours: number;
  weeklyOvertimeHours: number;
}

export interface TimecardReportRow {
  name: string;
  role: string;
  payRate: number;
  date: string;
  timeIn: string;
  timeOut: string;
  regularHours: number;
  overtime: number;
  doubleOvertime: number;
  weeklyOvertime: string;
  paidBreaks: number;
  unpaidBreaks: number;
  totalHoursExcludingUnpaidBreaks: number;
  netSale: number;
  tips: number;
  gratuity: number;
}
